//Note: Reuseable common function can be added here
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat)
function DateTimeFormat(value) {
  if (value && value !== "")
    return dayjs(value).format("MMM D, YYYY h:mm A")
  return value
}
//Return true if it is duplicate name
function isDuplicate(name, list, fieldName, referenceName) {
  //In edit - if Existing and new name are same no need to check duplicate
  if (name === referenceName) {
    return false
  }
  return list.some(val => val[fieldName] === name)
}

function isJSON(input) {
  try {
    JSON.parse(input);
    return true;
  } catch (e) {
    return false;
  }
}

function secondsToHourMinSec(d) {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor(d % 3600 / 60);
  var s = Math.floor(d % 3600 % 60);

  var hDisplay = h > 0 ? h + (h === 1 ? " hour" : " hours") : "";
  var mDisplay = m > 0 ? m + (m === 1 ? " minute" : " minutes") : "";
  var sDisplay = s > 0 ? s + (s === 1 ? " second" : " seconds") : "";

  // Combine the time components with commas
  var result = [hDisplay, mDisplay, sDisplay].filter(Boolean).join(", ");
  return result;
}

function secondsTohms(d) {
  d = Number(d);
  if (d) {
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);

    let hDisplay = h > 0 ? (h + "h ") : "";
    let mDisplay = m > 0 ? (m + "m ") : "";
    let sDisplay = s > 0 ? (s + "s") : "";
    return hDisplay + mDisplay + sDisplay;

  } else {
    return "0s"
  }

}

function secondsToClock(d) {
  d = Number(d);
  return d ? new Date(d * 1000).toISOString().slice(11, 19) : '00.00.00'
}

function formatBytes(bytes, decimals = 2) {
  if (bytes == 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

function relativeTime(current, previous) {
  var msPerMinute = 60 * 1000;
  var msPerHour = msPerMinute * 60;
  var msPerDay = msPerHour * 24;
  var msPerMonth = msPerDay * 30;
  var msPerYear = msPerDay * 365;

  var elapsed = current - previous;

  if (elapsed < msPerMinute) {
    let s = Math.round(elapsed / 1000);
    return s > 0 ? s + (s == 1 ? " second ago" : " seconds ago") : "";
  } else if (elapsed < msPerHour) {
    let m = Math.round(elapsed / msPerMinute);
    return m > 0 ? m + (m == 1 ? " minute ago" : " minutes ago") : "";
  } else if (elapsed < msPerDay) {
    let h = Math.round(elapsed / msPerHour);
    return h > 0 ? h + (h == 1 ? " hour ago" : " hours ago") : "";
  } else if (elapsed < msPerMonth) {
    let d = Math.round(elapsed / msPerDay);
    return d > 0 ? d + (d == 1 ? " day ago" : " days ago") : "";
  } else if (elapsed < msPerYear) {
    let m = Math.round(elapsed / msPerMonth);
    return m > 0 ? m + (m == 1 ? " month ago" : " months ago") : "";
  } else {
    let y = Math.round(elapsed / msPerYear);
    return y > 0 ? y + (y == 1 ? " year ago" : " years ago") : "";
  }
}

function deepEqual(x, y) {
  const ok = Object.keys, tx = typeof x, ty = typeof y;
  return x && y && tx === 'object' && tx === ty ? (
    ok(x).length === ok(y).length &&
    ok(x).every(key => deepEqual(x[key], y[key]))
  ) : (x === y);
}

function generateLastSixMonthOptions(addCustom = true) {
  let monthOptions = [];
  if (addCustom) {
    monthOptions.push({ 'label': 'Custom', 'value': 'custom' });
  }

  for (let i = 0; i < 6; i++) {
    const date = dayjs().subtract(i, 'month');
    monthOptions.push({
      label: date.format('MMMM'), // Name of month
      value: date.format('MM')    // 12"
    });
  }
  return monthOptions;
}
function getFirstDayOfMonth(month, year = dayjs().year()) {
  const currentDate = dayjs();
  const currentMonth = currentDate.format('MM');
  const currentYear = currentDate.year();

  // If the provided month is greater than the current month, it's from the previous year
  if (month > currentMonth && year === currentYear) {
    year = year - 1;
  }
  return dayjs(`${year}-${month.toString().padStart(2, '0')}-01`)
    .startOf('month')
    .format("YYYY-MM-DD");
}

function getLastDayOfMonth(month, year = dayjs().year()) {
  const today = dayjs();
  const currentMonth = today.format('MM');
  const currentYear = today.year();

  // If the provided month is greater than the current month, it's from the previous year
  if (month > currentMonth && year === currentYear) {
    year = year - 1;
  }
  // Create a date for the first day of the next month
  const nextMonth = dayjs(`${year}-${month.toString().padStart(2, '0')}-01`)
    .add(1, 'month');

  // Subtract one day to get the last day of the given month
  let lastDay = nextMonth.subtract(1, 'day');

  // If it's the current month and year
  if (month === today.format('MM') && year === today.year()) {
    lastDay = today;
  }

  return lastDay.format("YYYY-MM-DD");
}

function camelToTitle(camelCase) {
  return camelCase
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase())
    .trim();
}

function formatNumber(value, options = {}) {
  if (value === null || value === undefined) return '0';

  const num = Number(value);

  // Handle NaN
  if (isNaN(num)) return '0';

  // Handle very small numbers
  if (num !== 0 && Math.abs(num) < 0.0001) {
    return num.toExponential(1);
  }

  // Handle integers
  if (Number.isInteger(num) && !options.forceDecimals) {
    return num.toLocaleString('en-US');
  }

  // Handle decimals
  const decimals = options.decimals || 2;
  const fixed = Number(num.toFixed(decimals));
  return fixed.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}

// Reframe a metered-entitlement description as consumption for the usage dashboard:
// drop a trailing "Entitlement"/"Entitlements" and label it as "… Consumption"
// (e.g. "Usage Credit Entitlements" -> "Usage Credit Consumption").
function formatCreditLabel(description) {
  if (!description) return '';
  let base = String(description).trim().replace(/\s*entitlements?\s*$/i, '').trim();
  if (!base) base = String(description).trim();
  if (/consumption$/i.test(base)) return base;
  return `${base} Consumption`;
}

// Compact number for axis ticks / labels where raw counts run to millions or billions
// (e.g. 1,340,000,000 -> "1.3B").
function formatCompactNumber(value) {
  const num = Number(value);
  if (!isFinite(num)) return '0';
  return new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(num);
}

function getAgentStatusIcon(status, streaming = false) {
  let classStr = "";
  switch (status.toLowerCase()) {
    case "validating input":
      classStr = "fa-solid fa-shield-halved" + (streaming ? " text-success" : "");
      break;
    case "almost there":
      classStr = "fa-solid fa-indent" + (streaming ? " text-secondary" : "");
      break;
    case "executing query":
      classStr = "fa-solid fa-play" + (streaming ? " text-success" : "");
      break;
    case "reading references":
      classStr = "fa-solid fa-file-alt" + (streaming ? " text-primary" : "");
      break;
    case "thinking":
      classStr = "fa-solid fa-lightbulb" + (streaming ? " text-warning fa-fade" : "");
      break;
    case "loading skills":
      classStr = "fa-solid fa-graduation-cap" + (streaming ? " text-info" : "");
      break;
    case "show histogram visualization":
    case "show query visualization": 
      classStr = "fa-solid fa-chart-simple" + (streaming ? " text-primary" : "");
      break;
    case "searching tools":
      classStr = "fa-solid fa-magnifying-glass" + (streaming ? " text-primary" : "");
      break;
    case "running skill script":
      classStr = "fa-solid fa-code" + (streaming ? " text-primary" : "");
      break;
    case "get context layer":
      classStr = "fa-solid fa-layer-group" + (streaming ? " text-dark" : "");
      break;
    default:
      classStr = "fa-solid fa-gear" + (streaming ? " text-secondary fa-spin" : "");
  }
  return classStr;
}

// function to get the currently running status among the given status list.
// It will return an array of boolean with true for the current status and all previous status, false for finished status.
// If "thinking" status is present in the list, then it will consider all status before "thinking" as finished status.
function currentStatus(statusList) {
  const len = statusList?.length || 0;
  if (len == 0) return []

  let statusArr = new Array(len).fill(false);
  statusArr[len - 1] = true; // set the latest as current status

  for (let i = len - 1; i >= 0; i--) {
    if (statusList[i].label?.toLowerCase().trim() == "thinking") break;
    statusArr[i] = true;
  }
  return statusArr;
}


/**
 * Icon markup shown next to an execution id when the execution is a rerun (tag === "rerun").
 * RESUME continues from where the source execution stopped, RESTART runs it again from the start.
 */
function rerunIconHtml(rerunType) {
  switch ((rerunType || "").toUpperCase()) {
    case "RESUME":
      return '<i class="fa-regular fa-circle-play ms-1 text-primary" title="Rerun - resumed from the failed step"></i>';
    case "RESTART":
      return '<i class="fa-solid fa-rotate-right ms-1 text-primary" title="Rerun - restarted from the beginning"></i>';
    default:
      return '<i class="fa-solid fa-layer-group ms-1 text-primary" title="Rerun"></i>';
  }
}


export {
  DateTimeFormat,
  isDuplicate,
  isJSON,
  secondsTohms,
  secondsToHourMinSec,
  secondsToClock,
  formatBytes,
  relativeTime,
  deepEqual,
  generateLastSixMonthOptions,
  getFirstDayOfMonth,
  getLastDayOfMonth,
  camelToTitle,
  formatNumber,
  formatCompactNumber,
  formatCreditLabel,
  getAgentStatusIcon,
  currentStatus,
  rerunIconHtml
}
